import { GlobalMXContext } from '~/providers/mx-global-context/global-mx.context';

export function initGlobalMXContext({
    currentGlobalContext
}: {
    currentGlobalContext: GlobalMXContext;
}): GlobalMXContext {
    if (currentGlobalContext) {
        currentGlobalContext.fullstoryService.warn(
            'Tried to init global context but it is already init'
        );

        return currentGlobalContext;
    }

    const globalContext = new GlobalMXContext();

    if (
        process.env.NODE_ENV !== 'production' &&
        process.env.NODE_ENV !== 'test'
    ) {
        window._globalContext = globalContext;
    }

    return globalContext;
}

export function ensureGlobalMXContextInit(globalContext: GlobalMXContext) {
    if (!globalContext) {
        // To dev comment
        throw new Error(
            'You forgot to init the global mx context, please use "init" before using any context related functions.'
        );
    }
}
